export const SET_BLOCK_HEIGHT = 'SET_BLOCK_HEIGHT';
export const SET_SEARCH_INFO = 'SET_SEARCH_INFO';
export const SET_RUN_STATUS = 'SET_RUN_STATUS';
export const SET_ONT_ID_LIST = 'SET_ONT_ID_LIST';
export const SET_ONT_ID_LIST_PAGE = 'SET_ONT_ID_LIST_PAGE';
export const SET_ONT_ID_DETAIL_DDO_PAGE = 'SET_ONT_ID_DETAIL_DDO_PAGE';
export const SET_ONT_ID_DETAIL_TX_PAGE = 'SET_ONT_ID_DETAIL_TX_PAGE';
export const SET_BLOCK_LIST = 'SET_BLOCK_LIST';
export const SET_BLOCK_LIST_PAGE = 'SET_BLOCK_LIST_PAGE';
export const SET_BLOCK_DETAIL_PAGE = 'SET_BLOCK_DETAIL_PAGE';
export const SET_TRANSACTION_LIST = 'SET_TRANSACTIOM_LIST';
export const SET_TRANSACTION_LIST_PAGE = 'SET_TRANSACTION_LIST_PAGE';
export const SET_TRANSACTION_DETAIL_PAGE = 'SET_TRANSACTION_DETAIL_PAGE';
export const SET_TRANSACTIONSC_DETAIL_PAGE = 'SET_TRANSACTIONSC_DETAIL_PAGE';
export const SET_TRANSACTIONSC_INFO_PAGE = 'SET_TRANSACTIONSC_INFO_PAGE';
export const SET_TRANSACTIONSC_JSONINFO_PAGE = 'SET_TRANSACTIONSC_JSONINFO_PAGE';
export const SET_GENERATE_TIME = 'SET_GENERATE_TIME';
export const SET_ADDRESS_DETAIL_PAGE = 'SET_ADDRESS_DETAIL_PAGE';
export const SET_ADDRESS_OEP4_PAGE = 'SET_ADDRESS_OEP4_PAGE';
export const SET_ADDRESS_OEP5_PAGE = 'SET_ADDRESS_OEP5_PAGE';
export const SET_ADDRESS_OEP8_PAGE = 'SET_ADDRESS_OEP8_PAGE';
export const SET_ADDRESS_ORC20_PAGE = 'SET_ADDRESS_ORC20_PAGE';
export const SET_ADDRESS_ORC721_PAGE = 'SET_ADDRESS_ORC721_PAGE';
export const SET_ADDRESS_ORC1155_PAGE = 'SET_ADDRESS_ORC1155_PAGE';
export const SET_ADDRESS_NATIVE_PAGE = 'SET_ADDRESS_NATIVE_PAGE';
export const SET_ADDRESS_TX_PAGE = 'SET_ADDRESS_TX_PAGE';
export const SET_ASSET_TX_PAGE = 'SET_ASSET_TX_PAGE';
export const SET_ASSETTYPE_TX_PAGE = 'SET_ASSETTYPE_TX_PAGE';
export const SET_ADDRESS_LIST_PAGE = 'SET_ADDRESS_LIST_PAGE';
export const SET_OLD_ADDRESS_TX_PAGE = 'SET_OLD_ADDRESS_TX_PAGE';
export const SET_OLD_ASSET_TX_PAGE = 'SET_OLD_ASSET_TX_PAGE';
export const GET_CLAIM = 'GET_CLAIM';

export const UPDATE_NODE_LIST = 'UPDATE_NODE_LIST';
export const UPDATE_COUNTDOWN_BLOCK = 'UPDATE_COUNTDOWN_BLOCK';
export const UPDATE_NODE_INFO = 'UPDATE_NODE_INFO';
export const UPDATE_FETCH_PROCESS = 'UPDATE_FETCH_PROCESS';

export const SET_CONTRACTS_DATA = 'SET_CONTRACTS_DATA';
export const SET_CONTRACT_DATA = 'SET_CONTRACT_DATA';
export const SET_CONTRACT_TX_DATA = 'SET_CONTRACT_TX_DATA';

export const SET_TOKENS_DATA = 'SET_TOKENS_DATA';
export const SET_TOKEN_DATA = 'SET_TOKEN_DATA';
export const SET_TOKEN_LIST_DATA = 'SET_TOKEN_LIST_DATA';
export const SET_TOKENHOLDER_DATA = 'SET_TOKENHOLDER_DATA';
export const SET_TOKENHOLDERCOUNT_DATA = 'SET_TOKENHOLDERCOUNT_DATA';
export const SUBMIT_TOKEN_DATA = 'SUBMIT_TOKEN_DATA';

export const SET_STATISTICS_DATA = 'SET_STATISTICS_DATA';
export const SET_SC_LIST = 'SET_SC_LIST';
export const GET_NODE_LIST = 'GET_NODE_LIST';
export const GET_NODE_DETAIL = 'GET_NODE_DETAIL';
export const SET_NODECOUNT_STATUS = 'SET_NODECOUNT_STATUS';


export const SET_ADDRESS_ANALYTICS = 'SET_ADDRESS_ANALYTICS';
export const SET_ADDRESS_TOKEN_ANALYTICS = 'SET_ADDRESS_TOKEN_ANALYTICS';
export const SET_SC_ANALYTICS = 'SET_SC_ANALYTICS';
export const SET_SC_TOKEN_ANALYTICS = 'SET_SC_TOKEN_ANALYTICS';
export const SET_TOKEN_ANALYTICS = 'SET_TOKEN_ANALYTICS';

export const SET_ADDRESS_TOP = 'SET_ADDRESS_TOP';
export const SET_TOKEN_TOP = 'SET_TOKEN_TOP';

export const SET_TOKEN_PRICE = 'SET_TOKEN_PRICE';

/* USER */
export const SET_USER_QRCODE = 'SET_USER_QRCODE';
export const SET_USER_LOGIN = 'SET_USER_LOGIN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_UPDATE_INFO = 'SET_USER_UPDATE_INFO';
export const SET_USER_ADD = 'SET_USER_ADD';
export const SET_USER_DELETE = 'SET_USER_DELETE';




// WEBPACK FOOTER //
// ./src/store/mutation-type.js